import React from 'react'
import ReportOverview from '../components/ReportOverview'
import ReportUserTable from '../components/ReportUserTable'
import LoadingScreen from '../../../components/LoadingScreen'

export function createReportDetailsTab({ displayName }) {
  function ReportDetailsTab({
    activeTab,
    kpiData,
    cardsLoading = false,
    tableLoading = false,
    cardsLoadError = false,
    onRetryCards,
    data,
    currentPage,
    totalPages,
    onSearchQuery,
    searchQuery,
    onRowClick,
    pendingSettlementFilter,
    onPendingSettlementFilterChange,
    isSingleDayRange = true,
    shouldShowReset = false,
    onResetFilters = null,
    totalCount,
    perPage,
    onPageChange,
    onRowsPerPageChange,
    startDate,
    endDate,
    hasPendingSettlementQuery
  }) {
    return (
      <div className="report-tab-content ubiqua-motion-enter">
        {cardsLoading ? (
          <LoadingScreen text="Cargando indicadores..." minHeight="160px" />
        ) : (
          <ReportOverview
            kpiData={kpiData}
            activeTab={activeTab}
            cardsLoadError={cardsLoadError}
            onRetryCards={onRetryCards}
          />
        )}
        <ReportUserTable
          loading={tableLoading}
          {...{
            activeTab,
            data,
            currentPage,
            totalPages,
            totalCount,
            perPage,
            onPageChange,
            onRowsPerPageChange,
            startDate,
            endDate,
            searchQuery,
            onSearchQuery,
            onRowClick,
            pendingSettlementFilter,
            onPendingSettlementFilterChange,
            shouldShowReset,
            onResetFilters,
            isSingleDayRange,
            hasPendingSettlementQuery
          }}
        />
      </div>
    )
  }

  ReportDetailsTab.displayName = displayName
  return ReportDetailsTab
}
